<template>
    <fieldset class="fieldset">
        <legend>
            {{ trans('Resources') }}
        </legend>

        <div v-if="loading" class="text-center mb-2">
            <i class="icofont-spinner"></i>
        </div>

        <div v-if="!loading" class="form-group">
            <label class="form-control-label" for="assign-assignee">{{ trans('Assign') }}:</label>

            <div class="row">
                <div class="col">
                    <v-select
                        :options="possibleAssignees"
                        :getOptionKey="(option) => option.key"
                        class="form-control"
                        @update:modelValue="assigneeSelected"
                    >
                        <template v-slot:option="option">
                            <i v-if="option.type === 'person'" class="icofont-user"></i>
                            <i v-if="option.type === 'team'" class="icofont-people"></i>
                            <i v-if="option.type === 'equipment'" class="icofont-vehicle-cement"></i>
                            {{ option.label }}
                            <span
                                v-if="option.type === 'team'"
                                class="badge-round round-md float-right main-color-background"
                                >{{ option.count }}</span
                            >
                        </template>
                    </v-select>
                </div>
            </div>
            <!--/ row -->

            <!--            <div-->
            <!--                class="invalid-feedback"-->
            <!--                v-if="-->
            <!--                    form.errors.has('person_id')-->
            <!--                "-->
            <!--            >-->
            <!--                {{-->
            <!--                    form.errors.get("person_id")-->
            <!--                }}-->
            <!--            </div>-->

            <!--            <div-->
            <!--                class="invalid-feedback warning-feedback"-->
            <!--                v-if="already_assigned_message"-->
            <!--            >-->
            <!--                {{ already_assigned_message }}-->
            <!--            </div>-->
        </div>

        <template v-if="!loading && hasAssignees">
            <hr />

            <label>{{ trans('Assignee') }}</label>

            <div v-for="(resources, teamId) in assignedTeams" :key="'team-' + teamId">
                <div class="row">
                    <div class="col">
                        <div class="my-2">
                            <i class="icofont-people"></i>
                            {{ teams[teamId].title }}
                        </div>
                    </div>

                    <div class="col col-auto pl-0">
                        <button @click="unassignTeam(teamId)" type="button" class="btn btn-danger">
                            <i class="icofont-ui-delete"></i>
                        </button>
                    </div>
                </div>

                <!--                <div-->
                <!--                    class="invalid-feedback warning-feedback"-->
                <!--                    v-if="!validateAssignees(team.assignees)"-->
                <!--                >-->
                <!--                    {{-->
                <!--                        trans(-->
                <!--                            'When a team is planned, it has to have at least one team member working on the task',-->
                <!--                        )-->
                <!--                    }}-->
                <!--                </div>-->

                <template v-for="(isAssigned, personId) of resources.persons" :key="'team-assignee' + personId">
                    <div class="form-group m-0">
                        <div class="row">
                            <div class="col">
                                <span
                                    class="ml-3"
                                    :class="{
                                        'font-italic':
                                            persons[personId].deleted_at ||
                                            teams[teamId].persons.indexOf(parseInt(personId)) ===
                                                -1,
                                    }"
                                >
                                    <i class="icofont-user"></i>
                                    {{ persons[personId].last_name }}
                                    {{ persons[personId].first_name || '' }}
                                </span>
                            </div>

                            <div class="col col-auto pl-0" v-if="!persons[personId].deleted_at">
                                <div class="switch-form switch-form-sm">
                                    <label class="switch">
                                        <input
                                            type="checkbox"
                                            value="1"
                                            name="active"
                                            v-model="assignedTeams[teamId]['persons'][personId]"
                                        />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!--/ row -->

                        <!--                        <div class="invalid-feedback" v-if="form.errors.has('assignee_id')">-->
                        <!--                            {{ form.errors.get('assignee_id') }}-->
                        <!--                        </div>-->
                    </div>
                </template>

                <template v-for="(isAssigned, equipmentId) of resources.equipments" :key="'team-equipment-assignee' + equipmentId">
                    <div class="form-group m-0">
                        <div class="row">
                            <div class="col">
                                <span
                                    class="ml-3"
                                    :class="{
                                        'font-italic':
                                            persons[equipmentId].deleted_at ||
                                            teams[teamId].equipments.indexOf(parseInt(equipmentId)) ===
                                                -1,
                                    }"
                                >
                                    <i class="icofont-vehicle-cement"></i>
                                    {{ equipments[equipmentId].title }}
                                </span>
                            </div>

                            <div class="col col-auto pl-0" v-if="!equipments[equipmentId].deleted_at">
                                <div class="switch-form switch-form-sm">
                                    <label class="switch">
                                        <input
                                            type="checkbox"
                                            value="1"
                                            name="active"
                                            v-model="assignedTeams[teamId]['equipments'][equipmentId]"
                                        />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!--/ row -->

                        <!--                        <div class="invalid-feedback" v-if="form.errors.has('assignee_id')">-->
                        <!--                            {{ form.errors.get('assignee_id') }}-->
                        <!--                        </div>-->
                    </div>
                </template>

                <div class="mb-4" :key="'mb-' + teamId"></div>
            </div>

            <div
                v-for="(personId, index) of assignedPersons"
                :key="'person' + index"
                class="form-group"
            >
                <div class="row">
                    <div class="col">
                        <div
                            class="my-2"
                            :class="{
                                'font-italic': persons[personId].deleted_at,
                            }"
                        >
                            <i class="icofont-user"></i>
                            {{ persons[personId].last_name }}
                            {{ persons[personId].first_name || '' }}
                        </div>
                    </div>

                    <div class="col col-auto pl-0">
                        <button
                            @click="unassignPerson(personId)"
                            type="button"
                            class="btn btn-danger"
                        >
                            <i class="icofont-ui-delete"></i>
                        </button>
                    </div>
                </div>
                <!--/ row -->

                <!--                    <div class="invalid-feedback" v-if="form.errors.has('assignee_id')">-->
                <!--                        {{ form.errors.get('assignee_id') }}-->
                <!--                    </div>-->
            </div>

            <div
                v-for="(equipmentId, index) of assignedEquipments"
                :key="'equipment' + index"
                class="form-group"
            >
                <div class="row">
                    <div class="col">
                        <div
                            class="my-2"
                            :class="{
                                'font-italic': equipments[equipmentId].deleted_at,
                            }"
                        >
                            <i class="icofont-vehicle-cement"></i>
                            {{ equipments[equipmentId].title }}
                        </div>
                    </div>

                    <div class="col col-auto pl-0">
                        <button
                            @click="unassignEquipment(equipmentId)"
                            type="button"
                            class="btn btn-danger"
                        >
                            <i class="icofont-ui-delete"></i>
                        </button>
                    </div>
                </div>
            </div>
        </template>

        <div v-if="!fromSlot && amountOfAssignees > 1" class="form-group">
            <div class="row">
                <div class="col">
                    <label>{{ trans('Linked') }}</label>

                    <div class="switch-form">
                        <label class="switch">
                            <input
                                type="checkbox"
                                :value="1"
                                name="active"
                                v-model="linkedAssignees"
                            />
                            <span class="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <!--/ row -->
        </div>
    </fieldset>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        fromSlot: {
            type: Boolean,
        },
    },
    data() {
        return {
            linkedAssignees: this.modelValue.linkedAssignees,
            assignedTeams: this.modelValue.assignedTeams,
            assignedPersons: this.modelValue.assignedPersons,
            assignedEquipments: this.modelValue.assignedEquipments,
            loadingPersons: true,
            persons: {},
            loadingEquipments: true,
            equipments: {},
            loadingTeams: true,
            teams: {},
        };
    },
    computed: {
        loading() {
            return this.loadingPersons || this.loadingTeams || this.loadingEquipments;
        },
        hasAssignees() {
            return this.amountOfAssignees > 0;
        },
        amountOfAssignees() {
            return Object.keys(this.assignedTeams).length + this.assignedPersons.length + this.assignedEquipments.length;
        },
        possibleAssignees() {
            const persons = Object.values(this.persons)
                .filter((person) => {
                    return person.plannable && !person.deleted_at;
                })
                .map((person) => {
                    return {
                        id: person.id,
                        label: (person.last_name + ' ' + (person.first_name ?? '')).trim(),
                        type: 'person',
                        key: 'person' + person.id,
                    };
                });

            const teams = Object.values(this.teams)
                .filter((team) => {
                    return !team.deleted_at;
                })
                .map((team) => {
                    return {
                        id: team.id,
                        label: team.title,
                        count: team.persons.length + team.equipments.length,
                        type: 'team',
                        key: 'team' + team.id,
                    };
                });

            const equipments = Object.values(this.equipments)
                .filter((equipment) => {
                    return !equipment.deleted_at;
                    // return equipment.plannable && !equipment.deleted_at;
                })
                .map((equipment) => {
                    return {
                        id: equipment.id,
                        label: equipment.title.trim(),
                        type: 'equipment',
                        key: 'equipment' + equipment.id,
                    };
                });

            return [...persons, ...teams, ...equipments];
        },
    },
    methods: {
        loadPersons() {
            const url = route('planning.get-persons-for-planning-form');
            axios.get(url).then((response) => {
                this.persons = response.data;
                this.loadingPersons = false;
            });
        },
        loadTeams() {
            const url = route('planning.get-teams-for-planning-form');
            axios.get(url).then((response) => {
                this.teams = response.data;
                this.loadingTeams = false;

                const assignedTeams = this.assignedTeams;
                Object.entries(assignedTeams).forEach(([teamId]) => {
                    let teamPersons = this.teams[teamId].persons;
                    teamPersons.forEach((personId) => {
                        if( !this.assignedTeams[teamId]['persons'] ) {
                            this.assignedTeams[teamId]['persons'] = {};
                        }
                        if (!this.assignedTeams[teamId]['persons'][personId]) {
                            this.assignedTeams[teamId]['persons'][personId] = false;
                        }
                    });
                    let teamEquipments = this.teams[teamId].equipments;
                    teamEquipments.forEach((equipmentId) => {
                        if( !this.assignedTeams[teamId]['equipments'] ) {
                            this.assignedTeams[teamId]['equipments'] = {};
                        }
                        if (!this.assignedTeams[teamId]['equipments'][equipmentId]) {
                            this.assignedTeams[teamId]['equipments'][equipmentId] = false;
                        }
                    });
                });
            });
        },
        loadEquipment() {
            const url = route('planning.get-equipments-for-planning-form');
            axios.get(url).then((response) => {
                this.equipments = response.data;
                this.loadingEquipments = false;
            });
        },
        assigneeSelected(assignee) {
            if (assignee.type === 'team') {
                if (!this.assignedTeams[assignee.id]) {
                    this.assignedTeams[assignee.id] = {
                        persons: {},
                        equipments: {},
                    };
                    let persons = {};
                    this.teams[assignee.id].persons.forEach((personId) => {
                        persons[personId] = true;
                        this.unassignPerson(personId);
                    });
                    this.assignedTeams[assignee.id]['persons'] = persons;
                    let equipments = {};
                    this.teams[assignee.id].equipments.forEach((equipmentId) => {
                        equipments[equipmentId] = true;
                        this.unassignEquipment(equipmentId);
                    });
                    this.assignedTeams[assignee.id]['equipments'] = equipments;
                }
            }
            if (assignee.type === 'person') {
                let isInAssignedTeam = false;
                Object.entries(this.assignedTeams).forEach(([teamId, resources]) => {
                    const personIds = resources.persons;
                    if (assignee.id in personIds) {
                        this.assignedTeams[teamId]['persons'][assignee.id] = true;
                        isInAssignedTeam = true;
                    }
                });
                if (!isInAssignedTeam && this.assignedPersons.indexOf(assignee.id) === -1) {
                    this.assignedPersons.push(assignee.id);
                }
            }
            if (assignee.type === 'equipment') {
                let isInAssignedTeam = false;
                Object.entries(this.assignedTeams).forEach(([teamId, resources]) => {
                    const equipmentIds = resources.equipments;
                    if (assignee.id in equipmentIds) {
                        this.assignedTeams[teamId]['equipments'][assignee.id] = true;
                        isInAssignedTeam = true;
                    }
                });
                if (!isInAssignedTeam && this.assignedEquipments.indexOf(assignee.id) === -1) {
                    this.assignedEquipments.push(assignee.id);
                }
            }
        },
        unassignTeam(teamId) {
            delete this.assignedTeams[teamId];
        },
        unassignPerson(personId) {
            this.assignedPersons.splice(this.assignedPersons.indexOf(personId), 1);
        },
        unassignEquipment(equipmentId) {
            this.assignedEquipments.splice(this.assignedEquipments.indexOf(equipmentId), 1);
        },
        emitValues() {
            this.$emit('update:modelValue', {
                assignedTeams: this.assignedTeams,
                assignedPersons: this.assignedPersons,
                assignedEquipments: this.assignedEquipments,
                linkedAssignees: this.linkedAssignees,
            });
        },
    },
    created() {
        this.loadPersons();
        this.loadTeams();
        this.loadEquipment();
    },
    watch: {
        assignedPersons: {
            deep: true,
            handler() {
                this.emitValues();
            },
        },
        assignedTeams: {
            deep: true,
            handler() {
                this.emitValues();
            },
        },
        assignedEquipments: {
            deep: true,
            handler() {
                this.emitValues();
            },
        },
        linkedAssignees() {
            this.emitValues();
        },
    },
};
</script>

<style scoped></style>
